<template>
  <div>
    <b-row class="list-tabs" align-v="center">
      <b-col cols="8" md="10" lg="10" class="tabs">
        <b-nav>
          <slot></slot>
        </b-nav>
      </b-col>
      <b-col cols="4" md="2" lg="2" class="text-right">
        <slot name="cmd"></slot>
      </b-col>
    </b-row>
    <div class="nav-toggle text-right">
      <b-button :id="randomId" variant="secondary" class="label-nav" v-if="currentTabLabel">
        {{ currentTabLabel }}
      </b-button>
      <b-button :id="randomId" class="navbtn" v-else>
        <font-awesome-icon icon="ellipsis-h" class="padded"></font-awesome-icon>
      </b-button>
      <b-popover :target="randomId" placement="bottomleft" triggers="click blur">
        <b-nav vertical class="dropnav">
          <slot></slot>
          <slot name="mobileCmd"></slot>
        </b-nav>
      </b-popover>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .list-tabs {
    display: none;
    z-index: 1;
    margin: 16px 5px;
    margin-top: 1em;
    margin-bottom: 2em;
    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);

    &.no-margin {
      margin-bottom: 0;
    }

    .tabs {
      padding-left: 0;
    }

    .tabs /deep/ a {
      color: $steel;

      &.active {
        color: $white;
        border-bottom: 2px solid $white;
      }
      &:hover {
        color: $white;
      }

      margin-bottom: -2px;
      font-size: 1em;
      font-family: 'AvenirHeavy';
      @include media-breakpoint-down(md) {
        font-size: 0.8em;
        padding: .5em .7em;
      }
    }

    .cmd {
      flex-grow: 0;
      text-align: right;
    }
  }

  .nav-toggle {
    margin-top: 1em;
    margin-bottom: 0.5em;
    @include media-breakpoint-down(sm) {
      /* margin-top: 0; */
    }

    .label-nav {
      width: 100%;

      &::after {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.3em solid;
        border-right: 0.3em solid transparent;
        border-bottom: 0;
        border-left: 0.3em solid transparent;
      }
    }

    .navbtn {
      padding: 0 1em;
      border-radius: 4px !important;
    }
  }

  .dropnav /deep/ a {
    color: $steel;

    &.active {
      color: $white;
    }

    &.btn {
      background: none !important;
    }

    margin-bottom: -2px;
  }

  @include media-breakpoint-up(md) {

    .list-tabs {
      display: flex;
    }

    .nav-toggle {
      display: none;
    }
  }

</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'ObjectListTabs',
  components: {
    FontAwesomeIcon
  },
  props: {
    createLink: Object,
    createLabel: String
  },
  watch: {
    '$route': 'updateCurrentLabel'
  },
  data () {
    return {
      randomId: 'objectListToggle-' + (+new Date()) + ':' + Math.round(1000000 * Math.random()),
      currentTabLabel: null,
      checkLabelId: null
    }
  },
  mounted () {
    this.updateCurrentLabel()
    this.checkLabelId = window.setInterval(this.updateCurrentLabel, 250)
  },
  updated () {
    this.updateCurrentLabel()
  },
  beforeDestroy () {
    if (this.checkLabelId) window.clearInterval(this.checkLabelId)
  },
  methods: {
    updateCurrentLabel () {
      const nav = this.$el.querySelector('.dropnav a.active')
      if (!nav) return

      const label = this.$el.querySelector('.dropnav a.active').innerText
      if (this.currentTabLabel !== label) this.currentTabLabel = label
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/ObjectListTabs.vue